import { Component } from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { SharedService } from 'src/app/core/shared/shared.service';
import { switchMap, take, tap } from 'rxjs';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { TourAcceptService } from './tour-accept.service';
import { ActivatedRoute } from '@angular/router';
import { SharedModule } from '../../core/shared/shared.module';

@Component({
  selector: 'app-accpet-tour',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, InputTextModule, PasswordModule, ButtonModule, FormsModule, CheckboxModule, ToastModule, SharedModule],
  templateUrl: './tour-accept.component.html',
  styleUrls: ['./tour-accept.component.scss'],
  providers: [MessageService]
})
export class TourAcceptComponent {
  tourAcceptForm: FormGroup;
  checked: boolean = false;
  user: any;
  linkUsed: boolean = true;
  message: string = "";
  tourData:any = null;
  userData:any = null;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private tourAcceptService: TourAcceptService,
    private sharedService: SharedService,
    private messageService: MessageService
  ) {
    this.tourAcceptForm = this.fb.group({
      userId: ['', [Validators.required]],
      tourId: ['', Validators.required],
      token: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.tourAcceptForm.patchValue({
        userId: params['userId'],
        tourId: params['tourId'],
        token: params['token'],
      });

      //Get User Details
      this.getUser(params['userId']);

      //Get Tour Detail
      this.getTour(params['tourId']);

      // Check if link is already used
      this.checkIfLinkUsed(params['userId'], params['tourId'], params['token']);
    });
  }

  getUser(userId: string){
    this.tourAcceptService.getUser(userId).pipe(take(1))
    .subscribe({
      next: (res: any) => {
        this.userData = res;
      },
      error: (err) => {
        console.error('Error user data ', err);
      }
    });
  }

  getTour(tourId: string){
    this.tourAcceptService.getTour(tourId).pipe(take(1))
    .subscribe({
      next: (res: any) => {
        this.tourData = res;
      },
      error: (err) => {
        console.error('Error tour data ', err);
      }
    });
  }

  checkIfLinkUsed(userId: string, tourId: string, token: string) {
    this.tourAcceptService.isTourAccepted({ userId, tourId, token })
      .pipe(take(1))
      .subscribe({
        next: (res: any) => {
          this.linkUsed = res.alreadyAccepted; // true if link already used
          this.message = res.message;
        },
        error: (err) => {
          console.error('Error checking link', err);
        }
      });
  }

  onSubmit() {
    this.tourAcceptService.tourAccept(this.tourAcceptForm.value).pipe(
      take(1)
    ).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: res.success ? 'success' : 'warn',
          summary: res.success ? 'Confirmed' : 'Warning',
          detail: res.message || 'Request completed',
        });
        this.linkUsed = true;
        this.message = "Thank you! <br/>You have accpeted the tour!";
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err.error?.message || 'Failed to confirm',
        });
      }
    });
  }


  onCancel() {
    this.router.navigate(['/']); // or navigate to tours page
  }

}